<section class="w-full flex flex-wrap h-full">
    <form [formGroup]="form" class="w-full flex flex-wrap justify-center content-start">
        <div class="w-full flex flex-wrap mb-2 my-6">
            <span class="icon person-regular text-2xl text-green-500 item-center ml-1"></span>
            <span class="text-base font-medium">
                @if (registerStep == registerStepEnum.ProfileCompletion) {
                تکمیل پروفایل
                } @else {
                نام کاربری
                }
            </span>
        </div>
        <span class="w-full font-regular text-xs mb-[20px]">
            @if (registerStep == registerStepEnum.ProfileCompletion) {
            اطلاعات خود را وارد کن.
            } @else {
            یک نام کاربری برای خود انتخاب کن.
            }
        </span>


        @if (registerStep == registerStepEnum.ProfileCompletion) {
        <div class="relative w-full">
            <input autocomplete="one-time-code" formControlName="fullName"
                class="w-full h-14 mb-[20px] !bg-white dark:!bg-gray-800 border border-[#BDBDBD] pl-3 placeholder:text-gray-500"
                [ngClass]="{'!border-red-500': form.controls['fullName'].touched && form.controls['fullName'].invalid}"
                type="text" placeholder="نام و نام خانوادگی" />
            <span class="absolute right-[98px] top-[20%] text-green-500"
                [ngClass]="{'hidden': form.controls['fullName'].value }">
                *
            </span>
        </div>


        <div class="w-full flex flex-wrap">
            <div class="w-full h-14 flex items-center justify-between border border-[#BDBDBD] rounded-[8px]"
                (click)="datePicker.open()">
                <input class="flex-1 bg-white text-gray-700 placeholder-gray-400 focus:outline-none" readonly
                    [max]="maxDate" [min]="minDate" formControlName="birthDay" type="text" [matDatepicker]="datePicker"
                    placeholder="تاریخ تولد" />
                <mat-datepicker-toggle
                    class="cursor-pointer hover:bg-gray-100 hover:scale-90 dark:hover:bg-gray-800 w-10 h-10 rounded-full !text-gray-500 flex justify-center items-center ml-1"
                    matSuffix [for]="datePicker">
                </mat-datepicker-toggle>
                <mat-datepicker #datePicker></mat-datepicker>
            </div>
        </div>

        <div class="w-full flex flex-wrap mt-6">
            <p class="w-full font-regular text-xs mb-3 text-gray-900">جنسیت خود را انتخاب کن.</p>

            <mat-radio-group [formControl]="genderControl" (change)="onGenderChange(genderControl.value!)">
                <mat-radio-button class="!p-0" [value]="EGender.FEMALE">
                    <span class="text-xs sm:text-sm text-gray-700">زن</span>
                </mat-radio-button>

                <mat-radio-button class="!p-0 mx-6" [value]="EGender.MALE">
                    <span class="text-xs sm:text-sm text-gray-700">مرد</span>
                </mat-radio-button>

                <mat-radio-button class="!p-0" [value]="EGender.NONE">
                    <span class="text-xs sm:text-sm text-gray-700">ترجیح می‌دهم نگویم</span>
                </mat-radio-button>
            </mat-radio-group>
        </div>
        } @else if (registerStep == registerStepEnum.UsernameSetup) {
        <!-- ? username -->
        <div class="relative w-full flex flex-wrap justify-start content-start mb-3">
            <input formControlName="userName" autocomplete="one-time-code"
                class="w-full h-14 !bg-white dark:!bg-gray-800 border border-[#BDBDBD]" [ngClass]="{
                  '!border !border-red-500': (form.controls['userName'].touched && form.controls['userName'].invalid) || (isUsernameDuplicated && form.get('userName')?.value),
                }" type="text" dir="ltr" placeholder="نام کاربری (انگلیسی وارد کنید.)"
                (keydown.space)="$event.preventDefault()" />
            <div class="w-full flex mt-[20px]">
                <span class="icon circle-empty-regular text-gray-500 text-xl ml-2"
                    [ngClass]="{'checkmark-circle-regular !text-green-500 text-2xl': !form.get('userName')?.hasError('pattern') && form.get('userName')?.value , 'dismiss-circle-regular !text-red-700 dark:text-red-600':form.get('userName')?.hasError('pattern')}"></span>
                <span class="text-gray-500 font-regular text-sm"
                    [ngClass]="{' !text-green-500': !form.get('userName')?.hasError('pattern') && form.get('userName')?.value , '!text-red-700 dark:text-red-600':form.get('userName')?.hasError('pattern')}">
                    نام کاربری فقط با حروف انگلیسی شروع شود و می‌تواند شامل اعداد، نقطه و ـ (خط‌‌تیره) باشد.
                </span>
            </div>
            <div class="w-full flex flex-wrap mt-2 md:mt-4">
                <span class="icon circle-empty-regular text-gray-500 text-xl ml-2"
                    [ngClass]="{'checkmark-circle-regular !text-green-500 text-2xl': !isUsernameDuplicated && form.get('userName')?.value , 'dismiss-circle-regular !text-red-700 dark:text-red-600':isUsernameDuplicated}"></span>
                <span class="text-gray-500 font-regular text-sm"
                    [ngClass]="{' !text-green-500': !isUsernameDuplicated && form.get('userName')?.value , '!text-red-700 dark:text-red-600':isUsernameDuplicated && form.get('userName')?.value}">
                    نام کاربری نباید تکراری باشد.
                </span>
            </div>
            <div class="w-full flex flex-wrap mt-2 md:mt-4">
                <span class="icon circle-empty-regular text-gray-500 text-xl ml-2"
                    [ngClass]="{'checkmark-circle-regular !text-green-500 text-2xl': !form.get('userName')?.hasError('minlength') && form.get('userName')?.value , 'dismiss-circle-regular !text-red-700 dark:text-red-600': form.get('userName')?.hasError('minlength') && form.get('userName')?.value}"></span>
                <span class="text-gray-500 font-regular text-sm"
                    [ngClass]="{' !text-green-500': !form.get('userName')?.hasError('minlength') && form.get('userName')?.value , '!text-red-700 dark:text-red-600':form.get('userName')?.hasError('minlength') && form.get('userName')?.value}">
                    نام کاربری شما باید بیشتر از ۳ کاراکتر داشته باشد.
                </span>
            </div>
        </div>
        }






        <!-- <div class="relative w-full mb-3 rounded-lg">
            <input formControlName="password" autocomplete="one-time-code" class="w-full !bg-white border !border-[#BDBDBD]" type="text"
                placeholder="رمز عبور (حداقل ۶ کاراکتر)" [type]="passwordVisible ? 'text' : 'password'">
            <span class="absolute left-3 top-1/2 -translate-y-1/2 icon text-base text-gray-500 cursor-pointer"
                (click)="passwordVisible = !passwordVisible" [ngClass]="passwordVisible ? 'eye-off-filled' : 'eye-regular'">
            </span>
        </div> -->

        <!-- <div class="relative w-full mb-6 rounded-lg">
            <input autocomplete="one-time-code" formControlName="pass_repeat" class="w-full !bg-white border !border-[#BDBDBD]" type="text"
                placeholder="تکرار رمز عبور" [type]="repeatPasswordVisible ? 'text' : 'password'">

            <span class="absolute left-3 top-1/2 -translate-y-1/2 icon text-base text-gray-500 cursor-pointer"
                (click)="repeatPasswordVisible = !repeatPasswordVisible"
                [ngClass]="repeatPasswordVisible ? 'eye-off-filled' : 'eye-regular'">
            </span>
        </div> -->

        <!-- <div class="w-full mb-6">
            <p class="text-center text-xs text-gray-400">
                با ثبت‌نام در بهخوان
                <a class="text-xs text-green-500" href="https://behkhaan.ir/post/c61a04fb-179a-4e05-8b4c-8cadce3a8954"
                    target="_blank">شرایط و قوانین</a>
                استفاده از سرویس‌ها و قوانین
                حریم خصوصی
                آن را می‌پذیرم.
            </p>
        </div> -->


        <!-- <button [ngClass]="{'mb-3': googleData}" class="w-full btn btn btn-green-flat mb-2" [appButtonLoader]="registerationLoading" [disabled]="form.invalid && !isUsernameDuplicated"
            (click)="submitForm()">ثبت‌نام</button>

            @if (googleData) {
                <button class="w-full btn btn-green mb-4" (click)="loginWithOtp()">قبلاً ثبت‌نام کرده‌ام</button>
            } -->

    </form>
    <div class="w-full content-end mb-[10px] md:mt-10">
        <button class="btn-green-flat w-full rounded-[12px]" [appButtonLoader]="registerationLoading"
            [disabled]="isButtonDisabled" (click)="continue()">ادامه</button>
    </div>



</section>